import { FC, useState } from "react";
import { Box } from "../../../../../components/box";
import { Table } from "antd";
import { eContent } from "../constant/field-names";

export const ExportList: FC<{
  eRequests: any;
  setERequests: any;
  hiddenEdit?: boolean;
}> = ({ eRequests, setERequests, hiddenEdit }) => {
  const columns = [
    {
      title: "STT",
      dataIndex: "index",
      key: "index",
      render: (value: number, record: any, index: number) => <>{ (currentPage - 1) * pageSize + index + 1}</>,
    },
    {
      title: "Nhân sự/ mã NV đã đăng ký",
      dataIndex: eContent.registerPersonel,
      key: eContent.registerPersonel,
    },
    {
      title: "Nhân sự/ mã NV thay thế/bổ sung",
      dataIndex: eContent.replacePersonel,
      key: eContent.replacePersonel,
    },
    {
      title: "Cơ quan/ Đơn vị",
      dataIndex: eContent.department,
      key: eContent.department,
    },
    {
      title: "Lý do thay đổi",
      dataIndex: eContent.reason,
      key: eContent.reason,
    },
    {
      title: "Ghi chú",
      dataIndex: eContent.note,
      key: eContent.note,
    },
  ];

  const pageSize = 10; // Number of rows per page
  const [currentPage,setCurrentPage] = useState(1)

  return (
    <Box title="Chi tiết">
      <div style={{ overflowX: "scroll" }}>
        <Table
          columns={columns}
          dataSource={eRequests}
          pagination={{
            onChange: (page) => {
              setCurrentPage(page);
            },
            current: currentPage,
          }}
        />
      </div>
    </Box>
  );
};
